import React from "react";
import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from "framer-motion";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation, Keyboard } from 'swiper/modules';
import { Parallax, useParallax } from 'react-scroll-parallax';
import { Link } from "react-router-dom";

const About = () => {

  const [active, setActive] = useState("marketing");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Breadcrumb Hero Section */}
      <section className="breadcrumb-hero">
        <div className="breadcrumb-overlay"></div>
        <div className="breadcrumb-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* <div className="breadcrumb-tagline">
                  <span className="breadcrumb-line"></span>
                  <span className="breadcrumb-text">INTELLIGENTLY DRIVE BUSINESS GROWTH</span>
                </div> */}
                <h1 className="breadcrumb-title">
                  About <span className="breadcrumb-highlight">Profit Technologies</span>
                </h1>
                <Link to="/contact" style={{ textDecoration: 'none' }}>
                  <button className="breadcrumb-btn">
                    <span>CONNECT NOW</span>
                    <span className="breadcrumb-arrow">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="breadcrumb-pattern"></div>
      </section>

      {/* New About Us Section - Company Information */}
      <section className="about-section py-5">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Left Content */}
            <div className="col-lg-6">
              <div className="about-content-wrapper">
                <h2 className="intro-about-heading">
                  About <span className="text-gradient">Profit Technologies</span>
                </h2>
                <p className="about-description">
                  Profit Technologies is driven by a strong passion to be at the forefront of the digital revolution. Our core value is to provide the solutions that our Clients require, utilizing the potential that technology holds to redefine business processes. We consistently improve & expand our knowledge base in digital technologies and master them to help our clients improve their business' processes.
                </p>

              </div>
            </div>

            {/* Right Content - Image */}
            <div className="col-lg-6">
              <div className="about-image-container">
                <div className="about-shape-1"></div>
                <div className="about-shape-2"></div>
                <div className="about-shape-3"></div>
                <div className="about-image-wrapper">
                  <img
                    src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80"
                    alt="Modern Office Space"
                    className="about-main-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Values, Vision Section - New Professional Design */}
      <section className="mvv-section-new">
        <div className="mvv-animated-bg">
          <div className="mvv-floating-shape mvv-shape-1"></div>
          <div className="mvv-floating-shape mvv-shape-2"></div>
          <div className="mvv-floating-shape mvv-shape-3"></div>
        </div>

        <div className="container">
          {/* Section Header */}
          <div className="mvv-header">
            <span className="mvv-subtitle">OUR CORE PRINCIPLES</span>
            <h2 className="mvv-title">Mission • Vision • Values</h2>
          </div>

          {/* MVV Cards Grid */}
          <div className="mvv-grid">
            {/* Mission Card */}
            <div className="mvv-card-new mvv-mission">
              <div className="mvv-card-glow"></div>
              <div className="mvv-card-content">
                <div className="mvv-icon-wrapper">
                  <div className="mvv-icon-bg"></div>
                  <svg className="mvv-icon-svg" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2" opacity="0.3" />
                    <circle cx="32" cy="32" r="20" stroke="currentColor" strokeWidth="2" opacity="0.5" />
                    <circle cx="32" cy="32" r="12" stroke="currentColor" strokeWidth="2" />
                    <circle cx="32" cy="32" r="4" fill="currentColor" />
                    <line x1="32" y1="4" x2="32" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="32" y1="52" x2="32" y2="60" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="4" y1="32" x2="12" y2="32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="52" y1="32" x2="60" y2="32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
                <h3 className="mvv-card-title">Mission</h3>
                <p className="mvv-card-text">
                  To empower businesses with innovative technology solutions that drive growth,
                  efficiency, and digital transformation in an ever-evolving landscape.
                </p>
                <div className="mvv-card-number">01</div>
              </div>
            </div>

            {/* Vision Card */}
            <div className="mvv-card-new mvv-vision">
              <div className="mvv-card-glow"></div>
              <div className="mvv-card-content">
                <div className="mvv-icon-wrapper">
                  <div className="mvv-icon-bg"></div>
                  <svg className="mvv-icon-svg" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32 20C20 20 10 32 10 32C10 32 20 44 32 44C44 44 54 32 54 32C54 32 44 20 32 20Z" stroke="currentColor" strokeWidth="2" />
                    <circle cx="32" cy="32" r="8" stroke="currentColor" strokeWidth="2" />
                    <circle cx="32" cy="32" r="4" fill="currentColor" />
                    <path d="M28 28L24 24M36 28L40 24M28 36L24 40M36 36L40 40" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                </div>
                <h3 className="mvv-card-title">Vision</h3>
                <p className="mvv-card-text">
                  To become a global leader in technology innovation, recognized for delivering
                  cutting-edge solutions that shape the future of digital business.
                </p>
                <div className="mvv-card-number">02</div>
              </div>
            </div>

            {/* Values Card */}
            <div className="mvv-card-new mvv-values">
              <div className="mvv-card-glow"></div>
              <div className="mvv-card-content">
                <div className="mvv-icon-wrapper">
                  <div className="mvv-icon-bg"></div>
                  <svg className="mvv-icon-svg" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="12" y="12" width="40" height="40" rx="4" stroke="currentColor" strokeWidth="2" />
                    <path d="M22 32L28 38L42 24" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <circle cx="16" cy="16" r="2" fill="currentColor" />
                    <circle cx="48" cy="16" r="2" fill="currentColor" />
                    <circle cx="16" cy="48" r="2" fill="currentColor" />
                    <circle cx="48" cy="48" r="2" fill="currentColor" />
                  </svg>
                </div>
                <h3 className="mvv-card-title">Values</h3>
                <p className="mvv-card-text">
                  Excellence, integrity, innovation, and customer-centricity form the foundation
                  of everything we do, ensuring sustainable success for all stakeholders.
                </p>
                <div className="mvv-card-number">03</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cyber-who-we-are-section" style={{
        backgroundImage: 'linear-gradient(135deg, rgba(13, 27, 62, 0.95), rgba(24, 42, 79, 0.92)), url(https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        position: 'relative',
        padding: '100px 0',
        overflow: 'hidden'
      }}>
        {/* Animated Background Elements */}
        <div style={{
          position: 'absolute',
          top: '10%',
          right: '10%',
          width: '300px',
          height: '300px',
          background: 'radial-gradient(circle, rgba(74, 144, 226, 0.15), transparent)',
          borderRadius: '50%',
          filter: 'blur(40px)',
          animation: 'float 6s ease-in-out infinite'
        }}></div>
        <div style={{
          position: 'absolute',
          bottom: '10%',
          left: '10%',
          width: '250px',
          height: '250px',
          background: 'radial-gradient(circle, rgba(0, 188, 212, 0.15), transparent)',
          borderRadius: '50%',
          filter: 'blur(40px)',
          animation: 'float 8s ease-in-out infinite reverse'
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          {/* Title Section */}
          <div className="text-center mb-5" style={{
            animation: 'fadeInDown 1s ease-out'
          }}>
            <p style={{
              color: '#4a90e2',
              fontSize: '0.9rem',
              fontWeight: '600',
              letterSpacing: '3px',
              textTransform: 'uppercase',
              marginBottom: '15px'
            }}>YOUR DIGITAL DEFENSE PARTNER</p>
            <h2 style={{
              color: '#ffffff',
              fontSize: '3.5rem',
              fontWeight: '800',
              marginBottom: '20px',
              textShadow: '2px 2px 20px rgba(74, 144, 226, 0.3)',
              letterSpacing: '-1px'
            }}>
              Who We Are
            </h2>
            <div style={{
              width: '80px',
              height: '4px',
              background: 'linear-gradient(90deg, #4a90e2, #00bcd4)',
              margin: '0 auto',
              borderRadius: '2px'
            }}></div>
          </div>

          <div className="row align-items-center g-5">
            {/* Left Content */}
            <div className="col-lg-6">
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                padding: '40px',
                borderRadius: '20px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease'
              }}>
                <p style={{
                  color: '#ffffff',
                  fontSize: '1.2rem',
                  lineHeight: '2',
                  marginBottom: '25px',
                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                  textAlign: 'left'
                }}>
                  <span style={{
                    color: '#4a90e2',
                    fontWeight: '700',
                    fontSize: '1.3rem',
                    textShadow: '0 0 10px rgba(74, 144, 226, 0.5)',

                  }}>Profit Technologies</span> is more than just a cyber security company in India – we are your digital defense partner.
                </p>
                <p style={{
                  color: '#e8f0ff',
                  fontSize: '1.1rem',
                  lineHeight: '1.9',
                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                  textAlign: 'left'
                }}>
                  Our team consists of certified security experts, ethical hackers, and technology strategists with years of hands-on experience in combating advanced cyber threats. We combine human intelligence with cutting-edge tools to provide robust, real-time protection for your business.
                </p>

                {/* Stats Section */}
                <div className="row mt-4 g-3">
                  <div className="col-4">
                    <div style={{ textAlign: 'center', padding: '20px 10px' }}>
                      <h3 style={{
                        color: '#4a90e2',
                        fontSize: '2.5rem',
                        fontWeight: '800',
                        marginBottom: '5px',
                        textShadow: '0 0 20px rgba(74, 144, 226, 0.6)'
                      }}>7+</h3>
                      <p style={{ color: '#fff', fontSize: '0.9rem', margin: 0 }}>Years Experience</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div style={{ textAlign: 'center', padding: '20px 10px' }}>
                      <h3 style={{
                        color: '#00bcd4',
                        fontSize: '2.5rem',
                        fontWeight: '800',
                        marginBottom: '5px',
                        textShadow: '0 0 20px rgba(0, 188, 212, 0.6)'
                      }}>500+</h3>
                      <p style={{ color: '#fff', fontSize: '0.9rem', margin: 0 }}>Clients Protected</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div style={{ textAlign: 'center', padding: '20px 10px' }}>
                      <h3 style={{
                        color: '#4a90e2',
                        fontSize: '2.5rem',
                        fontWeight: '800',
                        marginBottom: '5px',
                        textShadow: '0 0 20px rgba(74, 144, 226, 0.6)'
                      }}>99.9%</h3>
                      <p style={{ color: '#fff', fontSize: '0.9rem', margin: 0 }}>Success Rate</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content - Sectors */}
            <div className="col-lg-6">
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                padding: '40px',
                borderRadius: '20px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
              }}>
                <h4 style={{
                  color: '#ffffff',
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  marginBottom: '30px',
                  textShadow: '1px 1px 10px rgba(74, 144, 226, 0.3)'
                }}>
                  We serve clients across sectors:
                </h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {[
                    { icon: '🏦', text: 'Banking & Finance' },
                    { icon: '🏥', text: 'Healthcare & Pharmaceuticals' },
                    { icon: '🏭', text: 'Manufacturing & Supply Chain' },
                    { icon: '🛒', text: 'E-commerce & Retail' },
                    { icon: '🏛️', text: 'Government & Public Sector' }
                  ].map((item, index) => (
                    <li key={index} style={{
                      padding: '18px 20px',
                      marginBottom: '12px',
                      background: 'linear-gradient(135deg, rgba(74, 144, 226, 0.1), rgba(0, 188, 212, 0.05))',
                      borderRadius: '12px',
                      fontSize: '1.15rem',
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid rgba(74, 144, 226, 0.2)',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)'
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateX(10px)';
                        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(74, 144, 226, 0.2), rgba(0, 188, 212, 0.1))';
                        e.currentTarget.style.borderColor = 'rgba(74, 144, 226, 0.5)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateX(0)';
                        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(74, 144, 226, 0.1), rgba(0, 188, 212, 0.05))';
                        e.currentTarget.style.borderColor = 'rgba(74, 144, 226, 0.2)';
                      }}>
                      <span style={{
                        fontSize: '1.8rem',
                        marginRight: '20px',
                        filter: 'drop-shadow(0 0 5px rgba(74, 144, 226, 0.5))'
                      }}>{item.icon}</span>
                      <span style={{
                        color: '#ffffff',
                        fontWeight: '500',
                        textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)'
                      }}>{item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default About;
